<template>
  <div class="ban">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane name="first">
        <span slot="label">
          Pending
          <el-badge :value="Pendingnum" size="mini" class="item"></el-badge>
        </span>
        <div class="demo-input-suffix">
          Selected
          <span>{{nubm}}</span>
          <el-select v-model="Batchoperationvalue" required clearable placeholder="Please choose" style="width:150px">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-button style="background:#8989ba;color:#fff;outline: none" @click="Batchoperation">Bulk apply</el-button>
        </div>

        <el-table ref="multipleTable" :data="tableData" border style="width: 100%"
          @selection-change="handleSelectionChange" @filter-change="handleFilterChange" v-loading="loading">
          <el-table-column type="selection" width="60" fixed="left"></el-table-column>
          <el-table-column prop="create_time" label="Created time" width="100"></el-table-column>
          <el-table-column prop="order_ref_id" label="Order No." show-overflow-tooltip></el-table-column>
          <el-table-column prop="orders_code" label="SFC order No."></el-table-column>
          <el-table-column prop="country" label="Destination country"></el-table-column>
          <el-table-column prop="shipping_method" label="Shipping method" width="120"></el-table-column>
          <el-table-column prop="estimated_amount" sortable label="Estimated amount(CNY)" width="120"></el-table-column>
          <el-table-column prop="buyer_checkout_message" :filters="status" :filter-multiple="false" column-key="status"
            filter-placement="right-start" show-overflow-tooltip label="Pending reason" width="150"></el-table-column>
          <el-table-column label="Operation" width="130" fixed="right">
            <template slot-scope="scope">
              <a @click="details(scope)">
                <i class="el-icon-more" style="color:#8989ba;font-size:22px;border:1px solid #8989ba"></i>
              </a>
              <a @click="perfect(scope)" style="margin-left: 10px;">
                <i class="el-icon-edit" style="color:#56de97;font-size:22px;border:1px solid #56de97;"></i>
              </a>
              <a @click="remove(scope)" style="margin-left: 10px;">
                <i class="el-icon-delete" style="color:#ff646a;font-size:22px;"></i>
              </a>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="Processing" name="second">
        <span slot="label">
          Processing
          <el-badge :value="processing" size="mini" class="item"></el-badge>
        </span>
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="create_time" label="Created time" width="100"></el-table-column>
          <el-table-column prop="order_ref_id" label="Order No." show-overflow-tooltip></el-table-column>
          <el-table-column prop="orders_code" label="SFC order No."></el-table-column>
          <el-table-column prop="country" label="Destination country"></el-table-column>
          <el-table-column prop="shipping_method" label="Shipping method" width="120"></el-table-column>
          <el-table-column prop="estimated_amount" sortable label="Estimated amount(CNY)" width="120"></el-table-column>
          <el-table-column label="Operation" width="100" fixed="right">
            <template slot-scope="scope">
              <a @click="details(scope)">
                <i class="el-icon-more" style="color:#8989ba;font-size:22px;border:1px solid #8989ba"></i>
              </a>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="Shipped" name="third">
        <span slot="label">
          Shipped
          <el-badge :value="shipped" size="mini" class="item"></el-badge>
        </span>
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="create_time" label="Created time" width="100"></el-table-column>
          <el-table-column prop="order_ref_id" label="Order No." show-overflow-tooltip></el-table-column>
          <el-table-column prop="orders_code" label="SFC order No."></el-table-column>
          <el-table-column prop="country" label="Destination country"></el-table-column>
          <el-table-column prop="shipping_method" label="Shipping method" width="120"></el-table-column>
          <el-table-column prop="estimated_amount" sortable label="Estimated amount(CNY)" width="120"></el-table-column>
          <el-table-column prop="tracking_number" label="Tracking No." width="150">

            <template slot-scope="scope">
              <a @click="trackingnumber(scope)">
                {{scope.row.tracking_number}}
              </a>
            </template>
          </el-table-column>
          <el-table-column label="Operation" width="100" fixed="right">
            <template slot-scope="scope">
              <a @click="details(scope)">
                <i class="el-icon-more" style="color:#8989ba;font-size:22px;border:1px solid #8989ba"></i>
              </a>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="Deleted" name="fourth">
        <span slot="label">
          Deleted
          <el-badge :value="deleted" size="mini" class="item"></el-badge>
        </span>
        <el-table ref="multipleTable" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="create_time" label="Created time" width="100"></el-table-column>
          <el-table-column prop="order_ref_id" label="Order No." show-overflow-tooltip></el-table-column>
          <el-table-column prop="orders_code" label="SFC order No."></el-table-column>
          <el-table-column prop="country" label="Destination country"></el-table-column>

          <el-table-column prop="estimated_amount" sortable label="Estimated amount(CNY)" width="120"></el-table-column>
          <!-- <el-table-column label="Operation" width="100" fixed="right">
            <template slot-scope="scope">
              <a @click="details(scope)">
                <i
                  class="el-icon-more"
                  style="color:#8989ba;font-size:22px;border:1px solid #8989ba"
                ></i>
              </a>
              <a @click="perfect(scope)" style="margin-left: 10px;">
                <i
                  class="el-icon-edit"
                  style="color:#56de97;font-size:22px;border:1px solid #56de97;"
                ></i>
              </a>
            </template>
          </el-table-column> -->
        </el-table>

        <el-pagination class="pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-tab-pane>
    </el-tabs>

    <div id="details">
      <deta-ils :visible="addVisible" :companyList="companyList" @clearAdd="clearAdd"></deta-ils>
      <Edit-ing :visible="editVisible" ref="mychild" :companyList="companyList" @clearEdit="clearEdit"></Edit-ing>
    </div>
  </div>
</template>
<script>
  import {
    orderlist,
    getorderproduct,
    updateorderstatus,
    processingorder
  } from "../api/orderlist";
  import { setItem, getItem } from "../../utils/locstorage";
  import { getToken } from "../../utils/auth";
  import details from "./details/details";
  import Editing from "./Editing/Editing";
  export default {
    components: {
      "deta-ils": details,
      "Edit-ing": Editing
    },
    data() {
      return {
        companyList: {},
        activeName: "",
        loading: true,
        nubm: "0",
        addVisible: false,
        editVisible: false,
        isActive: true,
        Queryproductval: "",
        total: 0,
        Pendingnum: 0,
        shipped: 0,
        deleted: 0,
        processing: 0,
        ordersstatus: "",
        currentPage: 1,
        pageSize: 10,
        statetip:
          "产品状态说明\n已同步-待完善信息：sku基础信息已同步，但需要完善信息后才可进行入库操作",
        tableData: [
          {
            orders_code: "EA0091190426000003",
            create_time: "2019-04-28 11:22:51",
            order_ref_id: "3936151",
            ship_country: "MX",
            shipping_fee: "0.00",
            buyer_checkout_message: "4545",
            orders_status: "2"
          }
        ],
        multipleSelection: [],
        status: [
          { text: "credit is running low", value: 1 },
          { text: "Insufficient inventory", value: 2 }
        ],
        options: [
          {
            value: "0",
            label: "Delete order"
          },

          {
            value: "4",
            label: "Delivery order"
          }
        ],
        Batchoperationvalue: ""
      };
    },
    created: function () {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
      //this.fetchData();
    },
    mounted() {
      // this.$refs.multipleTable.toggleRowSelection(this.tableData[0],true);//默认选中
      let param = {
        page: 1,
        pageSize: 10,
        orders_code: "",
        orders_status: 0
      };
      this.getlist(param);
    },

    methods: {

      handleFilterChange(val) {
        console.log(val);
        if (Object.keys(val)[0] == "status") {
        if (val.status.length > 0) {
          console.log(val.status[0])
          // this.statusType = val.status[0];
          // let param = {
          //   page: 1,
          //   pageSize: 10,
          //   statusType: val.status[0]
          // };
          // console.log(param);
          // this.getlist(param);
        } else {
          console.log(0)
          // this.statusType = 0;
          // let param = {
          //   page: 1,
          //   pageSize: 10,
          //   statusType: 0
          // };
          // console.log(param);
          // this.getlist(param);
        }
      }

      },






      getlist(param) {
        this.loading = true
        orderlist(param)
          .then(response => {
            console.log(response);
            this.loading = false
            if (response.data.ask == 1) {
              this.tableData = response.data.data.orders;
              if (param.orders_status == 0) {
                this.total = Number(response.data.data.final_pendding_count);
                this.activeName = "first";
              } else if (param.orders_status == 1) {
                this.total = Number(response.data.data.processing_count);
                this.activeName = "second";
              } else if (param.orders_status == 2) {
                this.total = Number(response.data.data.shipped_count);
                this.activeName = "third";
              } else if (param.orders_status == 3) {
                this.total = Number(response.data.data.deleted_count);
                this.activeName = "fourth";
              }
              this.Pendingnum = response.data.data.final_pendding_count;
              this.deleted = response.data.data.deleted_count;
              this.shipped = response.data.data.shipped_count;
              this.processing = response.data.data.processing_count;
            }
          })
          .catch(error => {
            this.loading = false
            console.log(error);
          });
      },
      filterstatus(value, row) {
        return row.buyer_checkout_message === value;
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        console.log(val);
        this.multipleSelection = val;
        this.nubm = val.length;
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(function (row) {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      trackingnumber(scope) {
        window.open("https://www.sendfromchina.com/track/track/track/tracknumbers/" + scope.row.tracking_number)

      },
      callbackFunction(result) {
        alert(result + "aaa");
      },

      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        let param = {
          page: 1,
          pageSize: val,
          orders_code: "",
          orders_status: this.ordersstatus
        };
        this.getlist(param);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        let param = {
          page: val,
          pageSize: this.pageSize,
          orders_code: "",
          orders_status: this.ordersstatus
        };
        this.getlist(param);
      },
      //批量操作
      Batchoperation() {
        console.log(this.Batchoperationvalue);
        if (this.Batchoperationvalue == "") {
          this.$message.error("Please choose the mode of operation.");
        } else if (this.multipleSelection.length == 0) {
          this.$message.error("Please select the operation object");
        } else {
          if (this.Batchoperationvalue == 0) {
            this.$confirm(
              "This action will delete the order and continue?",
              "Tips",
              {
                confirmButtonText: "Determine",
                cancelButtonText: "cancel",
                type: "warning"
              }
            )
              .then(() => {
                let ordersCodeArr = [];
                for (let i = 0; i < this.multipleSelection.length; i++) {
                  ordersCodeArr.push(this.multipleSelection[i].orders_code);
                }
                let param = {
                  ordersCodeArr: ordersCodeArr,
                  orders_status: 0
                };

                updateorderstatus(param)
                  .then(response => {
                    console.log(response);
                    if (response.data.ask == 1) {
                      let param = {
                        page: 1,
                        pageSize: 10,
                        orders_code: "",
                        orders_status: 3
                      };
                      this.ordersstatus = 3
                      this.getlist(param);
                    }
                  })
                  .catch(error => {
                    console.log(error);
                  });
              })
              .catch(() => { });

            console.log(this.multipleSelection);
          } else if (this.Batchoperationvalue == 4) {
            this.$confirm(
              "Whether to send orders in batches or not?",
              "Tips",
              {
                confirmButtonText: "Determine",
                cancelButtonText: "cancel",
                type: "warning"
              }
            )
              .then(() => {
                let ordersCodeArr = [];
                for (let i = 0; i < this.multipleSelection.length; i++) {
                  ordersCodeArr.push(this.multipleSelection[i].orders_code);
                }
                let param = {
                  ordersCodeArr: ordersCodeArr,
                  flag: 2
                };

                processingorder(param)
                  .then(response => {
                    console.log(response);
                    if (response.data.ask == 1) {
                      let param = {
                        page: 1,
                        pageSize: 10,
                        orders_code: "",
                        orders_status: 1
                      };
                      this.ordersstatus = 1
                      this.getlist(param);
                      this.$message({
                        type: "warning",
                        message: response.data.msg
                      });

                    } else {
                      let param = {
                        page: 1,
                        pageSize: 10,
                        orders_code: "",
                        orders_status: 0
                      };
                      this.ordersstatus = 0
                      this.getlist(param);
                    }
                  })
                  .catch(error => {
                    console.log(error);
                  });
              })
              .catch(() => { });



          }
        }
      },
      //完善信息
      perfect(scope) {
        console.log(scope.row);
        let orders_code = []
        orders_code.push(scope.row.orders_code)
        let param = {
          orders_code: orders_code
        };
        this.editVisible = true;

        getorderproduct(param)
          .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
              let responsedata = response.data.data;
              responsedata.orders_code = scope.row.orders_code;
              let param = {
                country_id: responsedata.ship_country
              };
              this.$refs.mychild.getgmethod(param)



              this.companyList = responsedata;
              //this.companyList.orders_code=scope.row.orders_code
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      //详情
      details(scope) {
        console.log(scope.row);
        let orders_code = []
        orders_code.push(scope.row.orders_code)
        let param = {
          orders_code: orders_code
        };
        this.addVisible = true;

        getorderproduct(param)
          .then(response => {
            console.log(response);
            if (response.data.ask == 1) {
              let responsedata = response.data.data;
              responsedata.orders_code = scope.row.orders_code;
              this.companyList = responsedata;
              //this.companyList.orders_code=scope.row.orders_code
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      //修改信息
      clearAdd() {
        this.addVisible = false;
      },
      clearEdit() {
        this.editVisible = false;
      },
      remove(scope) {
        this.$confirm("This action will delete the order and continue?", "Tips", {
          confirmButtonText: "Determine",
          cancelButtonText: "cancel",
          type: "warning"
        })
          .then(() => {
            let ordersCodeArr = [];
            ordersCodeArr.push(scope.row.orders_code);
            let param = {
              ordersCodeArr: ordersCodeArr,
              orders_status: 0
            };

            updateorderstatus(param)
              .then(response => {
                console.log(response);
                if (response.data.ask == 1) {
                  let param = {
                    page: 1,
                    pageSize: 10,
                    orders_code: "",
                    orders_status: 3
                  };
                  this.ordersstatus = 3
                  this.getlist(param);
                }
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => { });
      },

      handleClick(tab) {
        console.log(tab);

        if (tab.label == "Processing") {
          let param = {
            page: 1,
            pageSize: 10,
            orders_code: "",
            orders_status: 1
          };
          this.ordersstatus = 1
          this.getlist(param);
        } else if (tab.index == 0) {
          let param = {
            page: 1,
            pageSize: 10,
            orders_code: "",
            orders_status: 0
          };
          this.ordersstatus = 0
          this.getlist(param);
        } else if (tab.label == "Shipped") {
          let param = {
            page: 1,
            pageSize: 10,
            orders_code: "",
            orders_status: 2
          };
          this.ordersstatus = 2
          this.getlist(param);
        } else if (tab.label == "Deleted") {
          let param = {
            page: 1,
            pageSize: 10,
            orders_code: "",
            orders_status: 3
          };
          this.ordersstatus = 3
          this.getlist(param);
        }
      }
    }
  };
</script>
<style>
  .Synchronize {
    float: right;
    font-size: 14px;
    color: #8989ba;
  }

  .ban {
    background: #fff;
    margin: 20px;
    padding: 20px;
  }

  .demo-input-suffix {
    padding-bottom: 20px;
    text-align: left;
  }

  .input {
    width: 200px;
  }

  .pagination {
    margin-top: 20px;
  }

  a {
    color: #8989ba;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/OrderManagement/OrderManagement.vue